import { h, Component } from 'preact';
import { route } from 'preact-router';
import { TopAppBar, TopAppBarRow, TopAppBarTitle, TopAppBarSection, TopAppBarNavigationIcon } from '@rmwc/top-app-bar';
import '@rmwc/top-app-bar/styles';
import { Drawer, DrawerHeader, DrawerTitle, DrawerSubtitle, DrawerContent } from '@rmwc/drawer';
import '@rmwc/drawer/styles';
import { List, ListItem, ListDivider, ListGroup, ListGroupSubheader } from '@rmwc/list';
import '@rmwc/list/styles';
import { Button } from '@rmwc/button';
import '@rmwc/button/styles';
import style from './style.css';
import firebase from '../firebase.js';

export default class Header extends Component {
	state = {
		drawerOpened: false,
		showUserDialog:false
	};

	render({currentUrl, user, userFirestore, userClaims},{showUserDialog}){
	  return (
		<div>
		  <TopAppBar className="topappbar">
				<TopAppBarRow>
					<TopAppBarSection alignStart>
						{user&&<TopAppBarNavigationIcon icon="menu" onClick={() => {
							this.setState({
							drawerOpened: !this.state.drawerOpened
							})
						}}
						/>}
						<TopAppBarTitle>
							<img 
								class={style.temp_logo} 
								src="./assets/icons/cec-logo-gradient-white.png"
								onClick={e=>route('/')}/>
						</TopAppBarTitle>
					</TopAppBarSection>
					<TopAppBarSection alignEnd>
						{user ? <div class={style.user_image_container}>
							<img src={user.photoURL} onClick={e=>{
								document.getElementById("app").style.overflow = "hidden";
								this.setState({
									showUserDialog:true
								})
							}}></img>
						</div>:<span onClick={e=>{
							firebase.auth().signInWithRedirect(new firebase.auth.GoogleAuthProvider());
						}}>Sign In</span>}
					</TopAppBarSection>
				</TopAppBarRow>
			</TopAppBar>
			<div class={`${style.user_dropdown_dialog} ${showUserDialog?style['user_dropdown_dialog-active']:""}`}>
				{user && userFirestore && <div class={style.user_info_container}>
					<h2>{userFirestore.chineseName} {userFirestore.englishName}</h2>
					<p>{user.email}</p>
					<p>{userFirestore.studentid} {userFirestore.class}</p>
				</div>}
				<div class={style.user_quick_actions}>
					{user && userFirestore && <Button outlined onClick={e => {
						document.getElementById("app").style.overflow = "initial";
						this.setState({showUserDialog:false})
						route('profile')}}>
						My Profile
					</Button>}
					<Button 
						outlined 
						style={{color:'#b00020'}}
						onClick={e => {
							firebase.auth().signOut()
							this.setState({showUserDialog:false})
						}}
					>
						Sign Out
					</Button>
				</div>
			</div>
			{showUserDialog&& <div class={style.user_dropdown_cover}
				onClick={e=>{
					document.getElementById("app").style.overflow = "initial";
					this.setState({showUserDialog:false})
				}}
			></div>}
			<Drawer
				modal
				open={this.state.drawerOpened}
				onClose={() => {
					this.setState({
					drawerOpened: false
					});
				}}>
				<DrawerHeader>
					<DrawerTitle>Creative Electronics Club</DrawerTitle>
				</DrawerHeader>
				<DrawerContent>
					<List>
						<ListGroup>
							<ListItem 
								selected={currentUrl==""||currentUrl=="/"}
								onClick={e=>{
									this.setState({
										drawerOpened: false
									});
									route('/')
								}}
							>
							Home
							</ListItem>
							{(userClaims && (userClaims.userGroup || []).includes('CEC_MEMBER'))&& <ListItem 
								selected={currentUrl=="facilities"||currentUrl=="/facilities"}
								onClick={e=>{
									this.setState({
										drawerOpened: false
									});
									route('/facilities')
								}}
							>
							Facilities
							</ListItem>}
						</ListGroup>
						<ListDivider/>
						{(userClaims && (userClaims.userGroup || []).includes('CEC_ADMIN'))&& <ListGroup>
							<ListGroupSubheader>ADMIN MENU</ListGroupSubheader>
							<ListItem 
								selected={currentUrl=="admin/facilities"||currentUrl=="/admin/facilities"}
								onClick={e=>{
									this.setState({
										drawerOpened: false
									});
									route('/admin/facilities')
								}}
							>
							Manage Facilities
							</ListItem>
							<ListItem 
								selected={currentUrl=="admin/users"||currentUrl=="/admin/users"}
								onClick={e=>{
									this.setState({
										drawerOpened: false
									});
									route('/admin/users')
								}}
							>
							Manage Users
							</ListItem>
							{(userClaims && (userClaims.roles || []).includes('ADMIN'))&& <ListItem
								onClick={e=>{
									this.setState({
										drawerOpened: false
									});
									window.location.replace("https://cectable.web.app")
								}}>
							Firetable
							</ListItem>}
						</ListGroup>}
					</List>
				</DrawerContent>
			</Drawer>
		</div>
	  );
	}
  }
  